function RedirectPharmacyLink(state) {
  return state && state.bannerDetails !== undefined
    ? state.bannerDetails.pharmacyLink
    : '';
}
function RedirectGroceryLink(state) {
  return state && state.bannerDetails !== undefined
    ? state.bannerDetails.homePageLink
    : '';
}
function RegisterLogoLink(state) {
  return state && state.bannerDetails !== undefined
    ? state.bannerDetails.logoLink
    : '';
}

function ReferenceIDSelector(state) {
  return state && state.SubscriptionUserDetails !== undefined
    ? state.SubscriptionUserDetails.referenceId
    : '';
}

function UserDetailsSelector(state) {
  return state && state.UserDetails !== undefined ? state.UserDetails : '';
}

function SubscriptionDetailsSelector(state) {
  return state && state.SubscriptionUserDetails !== undefined
    ? state.SubscriptionUserDetails
    : '';
}
function heroTextSelector(state) {
  return state && state.bannerDetails !== undefined
    ? state.bannerDetails.heroText
    : '';
}

function AditionalInfoSelector(state) {
  return state && state.aditionalUserInfo !== undefined
    ? state.aditionalUserInfo
    : '';
}

function RecentCouponSelector(state) {
  return state?.incentiveNext?.recentCoupon
    ? state.incentiveNext.recentCoupon
    : '';
}

export {
  RedirectGroceryLink,
  RedirectPharmacyLink,
  ReferenceIDSelector,
  UserDetailsSelector,
  RegisterLogoLink,
  heroTextSelector,
  SubscriptionDetailsSelector,
  AditionalInfoSelector,
  RecentCouponSelector,
};
